import React from "react";

/** The owl mark on its own, for square/icon slots. Swaps to the white-bodied version on dark. */
export const Mark = ({ className = "h-12 w-auto", light = false }) => (
  light ? (
    <img src="/tharwy-mark-light.png" alt="Tharwy" className={`${className} object-contain`}
      data-testid="tharwy-mark" />
  ) : (
    <>
      <img src="/tharwy-mark.png" alt="Tharwy" className={`${className} object-contain dark:hidden`}
        data-testid="tharwy-mark" />
      <img src="/tharwy-mark-light.png" alt="" aria-hidden="true"
        className={`${className} object-contain hidden dark:block`} />
    </>
  )
);

/** The supplied logo artwork — owl + wordmark + slogan, used exactly as delivered.
 *  `light` forces the white version for always-dark panels. */
export const Logo = ({ className = "h-16 w-auto", light = false }) => (
  light ? (
    <img src="/tharwy-logo-light.png" alt="Tharwy — your wealth never sleeps."
      className={`${className} object-contain`} data-testid="tharwy-logo" />
  ) : (
    <>
      <img src="/tharwy-logo.png" alt="Tharwy — your wealth never sleeps."
        className={`${className} object-contain dark:hidden`} data-testid="tharwy-logo" />
      <img src="/tharwy-logo-light.png" alt="" aria-hidden="true"
        className={`${className} object-contain hidden dark:block`} />
    </>
  )
);

export const SLOGAN = { en: "your wealth never sleeps.", ar: "ثروتك لا تنام أبداً." };

/** Owl + wordmark, no slogan — for tight horizontal slots like an app header bar. */
export const Lockup = ({ className = "h-6 w-auto", light = false }) => (
  <img src={light ? "/tharwy-lockup-light.png" : "/tharwy-lockup.png"}
    alt="Tharwy" className={`${className} object-contain`} data-testid="tharwy-lockup" />
);

export const Brand = () => (
  <div className="flex items-center" data-testid="brand">
    <Logo className="h-14 sm:h-16 w-auto" />
  </div>
);
